import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Sun({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M11.3335 17.2921C9.87412 17.1101 8.59788 16.3385 7.75064 15.2232C7.48255 14.8703 7.25741 14.483 7.08302 14.0691C6.81497 13.4328 6.6668 12.7337 6.6668 12C6.6668 11.2662 6.81497 10.5671 7.08302 9.93088C7.25741 9.51694 7.48255 9.12963 7.75064 8.77673C8.59788 7.66146 9.87412 6.88989 11.3335 6.70791C11.5519 6.68068 11.7744 6.66665 12.0001 6.66665C12.2259 6.66665 12.4484 6.68068 12.6668 6.70791C14.1261 6.88989 15.4024 7.66146 16.2496 8.77673C16.5177 9.12963 16.7429 9.51695 16.9172 9.93088C17.1853 10.5671 17.3335 11.2662 17.3335 12C17.3335 12.7337 17.1853 13.4328 16.9172 14.0691C16.7429 14.483 16.5177 14.8703 16.2496 15.2232C15.4024 16.3385 14.1261 17.1101 12.6668 17.2921C12.4484 17.3193 12.2259 17.3333 12.0001 17.3333C11.7744 17.3333 11.5519 17.3193 11.3335 17.2921ZM8.00013 12C8.00013 9.79084 9.79099 7.99998 12.0001 7.99998C14.2093 7.99998 16.0001 9.79084 16.0001 12C16.0001 14.2091 14.2093 16 12.0001 16C9.79099 16 8.00013 14.2091 8.00013 12Z"
        fill={iconColor}
      />
      <Path
        d="M3.09587 17.9107L5.42874 16.5638C5.17559 16.1999 4.95188 15.8141 4.76105 15.4097L2.4292 16.756L3.09587 17.9107Z"
        fill={iconColor}
      />
      <Path
        d="M12.0001 3.99998C12.2246 3.99998 12.447 4.00923 12.6668 4.02736V1.33331H11.3335V4.02736C11.5533 4.00923 11.7756 3.99998 12.0001 3.99998Z"
        fill={iconColor}
      />
      <Path
        d="M18.5715 7.43619C18.8247 7.80002 19.0484 8.18588 19.2392 8.5903L21.5711 7.244L20.9044 6.0893L18.5715 7.43619Z"
        fill={iconColor}
      />
      <Path
        d="M19.2392 15.4097C19.0484 15.8141 18.8247 16.1999 18.5715 16.5638L20.9044 17.9107L21.5711 16.756L19.2392 15.4097Z"
        fill={iconColor}
      />
      <Path
        d="M12.0001 20C12.2246 20 12.447 19.9907 12.6668 19.9726V22.6666H11.3335V19.9726C11.5533 19.9907 11.7756 20 12.0001 20Z"
        fill={iconColor}
      />
      <Path
        d="M4.76106 8.59029C4.95188 8.18587 5.17559 7.80002 5.42875 7.43618L3.09587 6.08929L2.4292 7.244L4.76106 8.59029Z"
        fill={iconColor}
      />
    </Svg>
  );
}
